import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import Card from './Card';
import Avatar from './Avatar';
import { Link } from 'react-router-dom';
import { TrendingUp, Users } from 'lucide-react';
import Button from './Button';

interface SuggestedUser {
  id: string;
  username: string;
  avatar: string;
  role: string;
  followers: number;
}

interface TrendingTopic {
  id: string;
  name: string;
  count: number;
  category: string;
}

const suggestedUsers: SuggestedUser[] = [
  {
    id: '1',
    username: 'TechMaster486',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150',
    role: 'Tech Lead',
    followers: 3420
  },
  {
    id: '2',
    username: 'CodeArtisan92',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150',
    role: 'Data Scientist',
    followers: 2851
  },
  {
    id: '3',
    username: 'TechPioneer234',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150',
    role: 'Product Manager',
    followers: 4123
  }
];

const trendingTopics: TrendingTopic[] = [
  { id: '1', name: 'AI', count: 12543, category: 'Technology' },
  { id: '2', name: 'WebDev', count: 8932, category: 'Programming' },
  { id: '3', name: 'DataScience', count: 7621, category: 'Analytics' },
  { id: '4', name: 'CloudComputing', count: 6543, category: 'Infrastructure' },
  { id: '5', name: 'Cybersecurity', count: 5432, category: 'Security' }
];

export default function Sidebar() {
  const { theme } = useTheme();

  return (
    <div className="space-y-6">
      {/* Who to Follow */}
      <Card>
        <div className="p-4">
          <div className="flex items-center justify-between mb-4">
            <h2 className={`text-lg font-semibold flex items-center gap-2 ${
              theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
            }`}>
              <Users className="h-5 w-5 text-blue-500" />
              Who to Follow
            </h2>
            <Link
              to="/discover/people"
              className="text-sm text-blue-500 hover:text-blue-600"
            >
              View all
            </Link>
          </div>
          
          <div className="space-y-4">
            {suggestedUsers.map(user => (
              <div key={user.id} className="flex items-start gap-3">
                <Avatar src={user.avatar} alt={user.username} size="md" />
                <div className="flex-1 min-w-0">
                  <Link
                    to={`/user/${user.id}`}
                    className={`font-medium hover:underline block truncate ${
                      theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
                    }`}
                  >
                    @{user.username}
                  </Link>
                  <p className={`text-sm truncate ${
                    theme === 'dark' ? 'text-gray-400' : 'text-gray-500'
                  }`}>
                    {user.role}
                  </p>
                  <p className="text-xs text-gray-500">
                    {user.followers.toLocaleString()} followers
                  </p>
                </div>
                <Button
                  variant="secondary"
                  size="sm"
                >
                  Follow
                </Button>
              </div>
            ))}
          </div>
        </div>
      </Card>

      {/* Trending Topics */}
      <Card>
        <div className="p-4">
          <div className="flex items-center gap-2 mb-4">
            <TrendingUp className="h-5 w-5 text-blue-500" />
            <h2 className={`text-lg font-semibold ${
              theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
            }`}>
              Trending Topics
            </h2>
          </div>
          
          <div className="space-y-3">
            {trendingTopics.map(topic => (
              <Link
                key={topic.id}
                to={`/tag/${topic.name.toLowerCase()}`}
                className="block group"
              >
                <div className="flex items-start justify-between">
                  <div>
                    <span className={`font-medium group-hover:text-blue-500 transition-colors ${
                      theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
                    }`}>
                      #{topic.name}
                    </span>
                    <p className={`text-sm ${
                      theme === 'dark' ? 'text-gray-400' : 'text-gray-500'
                    }`}>
                      {topic.category}
                    </p>
                  </div>
                  <span className={`text-sm ${
                    theme === 'dark' ? 'text-gray-400' : 'text-gray-500'
                  }`}>
                    {topic.count.toLocaleString()}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </Card>
    </div>
  );
}